import { useCreateActivityPurchase } from 'api-hooks/order/activity';
import { ActivitySaleModel } from 'api-hooks/sale/activity';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { SeparatorVertical } from 'components/styles';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import ActivityPurchaseForm from './component/form';
import { ActivityPurchaseFormType } from './component/form-type';
export type ActivityPurchaseCreateParams = {
  defaultValues?: ActivityPurchaseFormType;
  activitySale?: ActivitySaleModel;
};
export default function ActivityPurchaseCreate(
  props: NavigationProps<NavigationRoutes.ActivityPurchasesCreate>,
) {
  const { mutateAsync, error } = useCreateActivityPurchase();

  const onResolve = useApprovalableEdit('activity-purchases');
  return (
    <>
      <ActivityPurchaseForm
        {...props}
        activitySale={props.navigation.params?.activitySale}
        defaultValues={props.navigation.params?.defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input: any) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
